import React, { Component } from 'react';
import PropTypes from 'prop-types';
import format from 'date-fns/format';

class StatusLabelLink extends Component {
  render () {
    let status = 'InStock';
    if (this.props.isDiscontinued) {
      status = 'Discontinued';
    } else if (this.props.isComingSoon || !this.props.remainingStock) {
      status = 'OutOfStock';
    } else if (this.props.specialShipDays || this.props.backorderShipDays) {
      status = 'LimitedAvailability';
    }

    return <link itemProp="availability" href={`http://schema.org/${status}`}/>;
  }
}

StatusLabelLink.propTypes = {
  remainingStock: PropTypes.number.isRequired,
  specialShipDate: PropTypes.number.isRequired,
  backorderShipDate: PropTypes.number.isRequired,
  isDiscontinued: PropTypes.bool.isRequired,
  isComingSoon: PropTypes.bool.isRequired,
};

export default StatusLabelLink;
